import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

import CustomModal from "../Bar/CustomModal";
import CustomModalBlockUser from "../Bar/CustomModalBlockUser";
import API from "../../config/api";
import { exportToExcel } from "../Helper/exportToExcel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import img1 from "../../assets/assets_theme/img/avatar/1.jpg"
import * as XLSX from "xlsx";

import moment from 'moment';
import CustomModalApproveUser from "../Bar/CustomModalApproveUser";
import CustomModalDailyTask from "../Bar/CustomModalDailyTask";
import { exportTaskReportPdf } from "../Helper/exportTaskReportPdf";

const DailyTaskIndex = () => {
  const [state, setState] = useState({
    page: 1,
    data: null,
    all_data: [],
    users: [],
    total: 0,
    limit: 100,
    s: "",
    month: "this_month",
  });

  const [selectData, setSelectData] = useState(null); // For modals

  useEffect(() => {
    getAllTask();
  }, []); // Run once on mount

  const exportUsersToExcelClient = (data, filename) => {
    exportToExcel(data, filename);
  }

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellText: false, cellDates: true });

      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const filteredData = jsonData.slice(1);

      let file_data = [];

      filteredData.forEach((data, index) => {
        const date = new Date(data[3]);
        const formattedDate = moment(date).format("YYYY-MM-DD")

        if (data && data.length !== 0) {
          file_data.push({
            first_name: data[0],
            last_name: data[1],
            custom_id: data[2],
            dob: formattedDate,
          })
        }
      });

      try {
        let results = await API.postUser(file_data);
        if (results.result) {
          toast.success("Your action is successful", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
        }
        getAllTask();

      } catch (error) {
        console.log(error)
      }
    };

    reader.readAsArrayBuffer(file);
  }

  const getAllTask = async (pageNum, search, monthFilter) => {
    const currentPage = pageNum !== undefined ? pageNum : state.page;
    const currentSearch = search !== undefined ? search : state.s;
    const currentMonth = monthFilter !== undefined ? monthFilter : state.month;

    try {
      let query = `page=${currentPage}&s=${currentSearch}&month=${currentMonth}&limit=${state.limit}`;

      let results = await API.getAllDailyTask(query);

      let data = results.data;

      setState(prev => ({
        ...prev,
        all_data: data,
        total: data.total || 0, // API might not return total/limit in the same structure as others based on original code usage
        limit: data.limit || prev.limit,
        page: currentPage,
        s: currentSearch,
        month: currentMonth
      }));

    } catch (error) {
      console.log(error)
    }
  }

  const exportToPdf = (data, filename) => {
    exportTaskReportPdf(data.data, filename)
  }

  const onSearch = async (event) => {
    event.preventDefault();
    const s = event.target.value;
    getAllTask(1, s, undefined);
  }

  const onPaginationPress = (page) => {
    getAllTask(page, undefined, undefined);
  }

  const deleteUser = async (event) => {
    event.preventDefault();
    let data = {
      user_id: selectData.id // Use selectData which is set when button is clicked
    }
    try {
      let results = await API.postDeleteUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllTask();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const blockUser = async (event) => {
    event.preventDefault();
    let data = {
      user_id: selectData.id,
      block: selectData.block ? 0 : 1
    }
    try {
      let results = await API.postBlockUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllTask();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const approveUser = async (event) => {
    event.preventDefault();
    let data = {
      id: selectData.id,
      approve: selectData.approve ? 0 : 1
    }
    try {
      let results = await API.approveUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllTask();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const linkToNewPage = async (id) => {
    let element = document.getElementById(`clickview${id}`);
    if (element) element.click();
  }

  let sort_by = {
    this_month: { name: "This Month" },
    last_month: { name: "Last Month" },
    last_3months: { name: "Last 3 Months" }
  }

  let displaySort = "This month";

  if (state.month === "this_month") {
    displaySort = sort_by.this_month.name;
  } else if (state.month === "last_month") {
    displaySort = sort_by.last_month.name;
  } else if (state.month === "last_3month") {
    displaySort = sort_by.last_3months.name;
  }

  return (
    <div className="col-12 ">
      <ToastContainer />
      <div className="card card-body card-hover-shadow p-40">
        <h4 className="card-title"><strong>Daily Task of Users:<b className="text-success fw-500 w-80px"> {state.all_data?.length}</b></strong> <i className="fa fa-users"> </i></h4>

        <div className="card-body">

          <div className="flexbox mb-20">
            <div className="lookup">
              <input className="w-250px" type="text" name="s" placeholder="Search" onChange={onSearch} />
            </div>

            <div className="btn-toolbar">
              <div className="btn-group btn-group-sm">
                {/* <Link to="/useredit" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round" ></i></button></Link> */}

                &emsp;<button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Sort By: {displaySort}</button>
                <div className="dropdown-menu dropdown-menu-right">
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    getAllTask(undefined, undefined, "this_month");
                  }}><i className="fa fa-users"></i>This Month</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    getAllTask(undefined, undefined, "last_month");
                  }}><i className="fa fa-check"></i>Last Month</Link>

                </div>

              </div>

              <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">

                {/* <button className="btn btn-info" onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("importExcel").click()
                        }}><i class="fa fa-file-excel-o"></i> Import</button> */}
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={handleFileUpload}
                  hidden
                  id="importExcel"
                />

                {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button> */}
                <div className="dropdown-menu dropdown-menu-right">
                  <Link className="dropdown-item" to="#" ><i className="fa fa-file-zip-o"></i> Zip</Link>
                  <Link className="dropdown-item" to="#" ><i className="fa fa-file-pdf-o"></i> PDF</Link>
                  {/* <Link class="dropdown-item" onClick={this.exportToExcel} ><i class="fa fa-file-excel-o"></i> Excel</Link> */}
                  {/* <Link class="dropdown-item" onClick={this.testExport(this.state.users, "user data")} ><i class="fa fa-file-excel-o"></i> Excel</Link> */}
                  <Link className="dropdown-item" onClick={(event) => { exportUsersToExcelClient(state.users, "task user") }} to="#" ><i className="fa fa-file-pdf-o"></i> Excel</Link>
                </div>
              </div>
            </div>
          </div>
          <div>
          </div>

          <table className="table table-hover table-has-action">
            <thead>
              <tr>
                <th className="text-center w-20px"><h6>#</h6></th>
                <th className="text-center w-40px"><h6>Profile</h6></th>
                <th className="text-center w-180px"><h6>User Name</h6></th>
                <th className="text-center w-200px"><h6>Phone Number</h6></th>
                {/* <th className="text-center w-120px"><h6>Gender</h6></th> */}
                <th className="text-center w-200px"><h6>Email</h6></th>
                <th className="text-center w-150px"><h6>Date</h6></th>
                <th className="text-center  w-200px "><h6>Actions</h6></th>
              </tr>
            </thead>
            <tbody>
              {
                state.all_data && state.all_data.map((data, index) => {
                  let user = data.user;
                  // let task = data.task; // Unused
                  let backgroundColor = "";

                  return <tr key={index} style={{ background: backgroundColor }}>
                    <th onClick={() => linkToNewPage(user.id)} className="text-center w-20px" scope="row"><b>{index + 1}</b></th>

                    {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={user.profile_url} alt="user profile" /></td> */}
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-40px">
                      <div className="media">
                        {/* <img class="avatar" src={user.profile_url ? user.profile_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." /> */}
                        <img className="avatar" src={user.profile_url ? user.profile_url : img1} alt="..." />
                        <div className="media-body">
                          {/* <p >{video.title_kh}</p> */}
                        </div>
                      </div>
                    </td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-180px"><strong>{user.last_name + ' ' + user.first_name}</strong></td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px">{user.phone_number}</td>
                    {/* <td className="text-center w-120px">{user.gender_id === 1 ? "Male" : user.gender_id === 2 ? "Female" : "Other"}</td> */}
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px">{user.email}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-150px">{moment(user.created_at).format("DD-MMM-YYYY")}</td>
                    {/* <td className="text-right table-actions"></td> */}
                    <td className="text-center table-actions text-center ">
                      <span>&nbsp;</span><button title="View" onClick={() => setSelectData(data)} className="btn btn-square btn-round btn-primary" data-toggle="modal" data-target="#modal-center-daily-task"><i id={`clickview${user.id}`} className='fa fa-eye'></i> </button>
                      <span>&nbsp;</span><Link title="Download" onClick={() => exportToPdf({ data: data }, 'Daily Task')} className="btn btn-square btn-round btn-success" to="#"><i className='fa fa-file-pdf-o' ></i> </Link>
                    </td>
                  </tr>
                })
              }
            </tbody>
          </table>
          {/* <Pagination 
                onPaginationPress={onPaginationPress}
                totalPageLength = {state.total}
                limit = {state.limit}
                selectPage = {state.page}
              /> */}
        </div>
      </div>
      {
        selectData &&
        <CustomModalDailyTask
          data={selectData}   // passed data.data which was just data in map
          title="View Task"
          deleteQuiz={deleteUser}
          month={state.month}
        />
      }
      {
        selectData &&
        <CustomModal
          data={selectData}
          title="Do you really want to delete this user?"
          deleteQuiz={deleteUser}
        />
      }
      {
        selectData &&
        <CustomModalBlockUser
          data={selectData}
          title={selectData.block ? "Do you really want to unblock this user?" : "Do you really want to block this user?"}
          blockUser={blockUser}
          approveUser={approveUser}
        />
      }
      {
        selectData &&
        <CustomModalApproveUser
          data={selectData}
          title={selectData.block ? "Do you really want to approve this user?" : "Do you really want to disapprove this user?"}
          approveUser={approveUser}
        />
      }
    </div>
  );
}

export default DailyTaskIndex;
